<mat-card>

    <div fxFlex="100" class="px-2">
        <form [formGroup]="uploadForm" (ngSubmit)="onSubmit()">
            <div fxLayout="row wrap">
                <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Training Manual Title</mat-label>
                        <input matInput placeholder="Training Title" formControlName="trainingTitle" required>
                    </mat-form-field>
                </div>
                <!-- <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Training Manual Type</mat-label>
                        <input matInput placeholder="Type" formControlName="type" required>
                    </mat-form-field>
                </div> -->
                <!-- <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Training Manual Description</mat-label>
                        <input matInput placeholder="Training Desc" formControlName="trainingDesc" required>
                    </mat-form-field>
                </div> -->           

                <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Products</mat-label>
                        <mat-select formControlName="productId" required>
                            <mat-option *ngFor="let product of products" [value]="product.productId">
                                <span>{{product.productName}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div fxLayout="row wrap">

                <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                    <mat-form-field appearance="outline" class="w-100 mt-2">
                        <input hidden matInput placeholder="Upload file jpg,png, etc.">
                        <input type="file" multiple class="form-control" id="file" (change)="onImageChange($event)">
                        <input type="hidden" formControlName="imageUrl" />
                    </mat-form-field>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="50" class="px-1" fxLayoutAlign="center center">
                    <button mat-flat-button color="primary" class="mat-elevation-z6" type="submit">
                        SUBMIT
                    </button>
                </div>
            </div>
        </form>

    </div>
</mat-card>